
import {timer as observableTimer, of as observableOf,  Observable } from 'rxjs';

import {map} from 'rxjs/operators';
import { AbstractControl, ValidationErrors } from "@angular/forms";

const PHONE_NUMBER_REGEXP = new RegExp(/^\s*(?:\+(\d{1,3}))?[- (]*(\d{3})[- )]*(\d{3})[- ]*(\d{4})(?: *[x/#]{1}(\d+))?\s*$/);

export function isValidPhoneNumber(control: AbstractControl): Observable<ValidationErrors | null> {
    let value = control && control.value;

    //If the control is empty, there is no validation error.
    if (!value) {
        return observableOf({});
    }

    //Strip leading 1s from the phone number.
    value = value.replace(/^1+/, '');

    //If the phone number does not match the regex, or if it is longer than
    //10 digits after removing non-digit characters, return a validation error.
    if (!PHONE_NUMBER_REGEXP.test(value) || value.replace(/\D/g, '').length > 10) {
        return observableTimer(500).pipe(map(() => ({
            phoneNumber: true
        })));
    }

    //There is no validation error.
    return observableOf({});
}
